module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aG0oW"))).then(() => parcelRequire('1iHdE'));